import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import CustomNavigate from '../components/CustomNavigate';

export default function NotLoggedMiddleware({ children }) {
    const { user } = useAuth();
    const location = useLocation();

    const hasInvitation = new URLSearchParams(location.search).has('organizationInvitationToken');

    if (user) return <CustomNavigate to={hasInvitation ? "/auth/accept-invitation" : "/dashboard/home"} />;
    return children;
}

NotLoggedMiddleware.propTypes = {
    children: PropTypes.node.isRequired,
};
